export default "__VITE_ASSET__Ko0fD2yp__"